module.exports = __webpack_public_path__ + "img/n3.dacca94d.png";